export default "__VITE_ASSET__D93r28dh__"